import React from "react";

import Reckoner from "../component/Reckoner";
import "./ReadyReckoner.css";

const ReadyReckoner = () => {
  return (
    <div>
      <h1 className="headingH1"> READY RECKONER</h1>
      <div className="container">
        <Reckoner />
      </div>
    </div>
  );
};

export default ReadyReckoner;
